/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";

// import images
import logo from "../../assets/images/logo_new.svg";
import ConfirmModal from "../confirmModal/confirmModel";
import Constant from "../../util/constant";
import { clearAuthSession } from "../../helpers/authSession";
import { useDispatch } from "react-redux";
import { closeMobileSidebarDrawer, toggleBodySidebarClasses } from "../../util/sidebarToggle";
/**
 * A functional component that renders the sidebar content.
 * @param {object} props - The props passed to the component.
 * @returns The JSX elements representing the sidebar content.
 */
const SidebarContent = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isSubMenuOpen, setSubMenuOpen] = useState(
    location.pathname.includes("events-list") ||
      location.pathname.includes("clubs-management") ||
      location.pathname.includes("category-management") ||
      location.pathname.includes("genres-management")
  );
  const [activeSubMenuItem, setActiveSubMenuItem] = useState(() => {
    if (location.pathname.includes("event-phases")) return "event-phases";
    if (location.pathname.includes("events-list")) return "events-list";
    if (location.pathname.includes("club-managers")) return "club-managers";
    if (location.pathname.includes("clubs-management")) return "clubs-management";
    if (location.pathname.includes("category-management"))
      return "category-management";
    if (location.pathname.includes("genres-management")) return "genres-management";
    return null;
  });
  const isSalesAnalysisRoute = location.pathname.includes("club-sales-analysis");
  const salesReportSection =
    new URLSearchParams(location.search).get("section") === "event-end"
      ? "event-end"
      : "sales";
  const [isSalesSubMenuOpen, setSalesSubMenuOpen] = useState(
    isSalesAnalysisRoute
  );

  const [showLogoutModal, setLogoutModal] = useState(false);

  const closeLogoutModal = () => setLogoutModal(false);
  const toggleSubMenu = () => {
    setSubMenuOpen(!isSubMenuOpen);
  };

  const toggleSalesSubMenu = () => {
    setSalesSubMenuOpen(!isSalesSubMenuOpen);
  };

  const toggleSlider = () => {
    toggleBodySidebarClasses();
  };

  const openLogoutModal = (e, item) => {
    closeMobileSidebarDrawer();
    setLogoutModal(true);
  };

  const onLogout = async () => {
    await clearAuthSession(dispatch);
    closeLogoutModal();
    navigate("/", { replace: true });
  };

  return (
    <>
      <div id="sidebar-menu">
        <div className="navbar-brand-box">
          <Link
            // to="genres-management"
            className="logo logo-dark"
          >
            <span className="logo-sm">
              <img src={logo} alt="genres-management" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="genres-management" />
            </span>
          </Link>
        </div>
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">{t("MANAGEMENT")}</li>
          <>
            {/* User management — hidden from admin sidebar
            <li>
              <NavLink
                to="users-management"
                className={({ isActive }) => (isActive ? "active" : "inactive")}
                onClick={() => {
                  setActiveSubMenuItem(null);
                  toggleSlider();
                }}
              >
                <div className="left-menu">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                  >
                    <path d="M10.0004 2.16699C7.70285 2.16699 5.83348 4.03637 5.83348 6.33387C5.83348 8.63137 7.70285 10.5007 10.0004 10.5007C12.2979 10.5007 14.1672 8.63137 14.1672 6.33387C14.1672 4.03637 12.2979 2.16699 10.0004 2.16699ZM10.0004 8.83324C8.62223 8.83324 7.50035 7.71137 7.50035 6.33324C7.50035 4.95512 8.62223 3.83324 10.0004 3.83324C11.3785 3.83324 12.5004 4.95512 12.5004 6.33324C12.5004 7.71137 11.3785 8.83324 10.0004 8.83324ZM17.5004 18.0001V17.167C17.5004 13.9514 14.8829 11.3339 11.6672 11.3339H8.3341C5.11723 11.3339 2.50098 13.9514 2.50098 17.167V18.0001H4.16785V17.167C4.16785 14.8695 6.03723 13.0001 8.33473 13.0001H11.6679C13.9654 13.0001 15.8347 14.8695 15.8347 17.167V18.0001H17.5016H17.5004Z" />
                    <path
                      d="M10.0004 2.16699C7.70285 2.16699 5.83348 4.03637 5.83348 6.33387C5.83348 8.63137 7.70285 10.5007 10.0004 10.5007C12.2979 10.5007 14.1672 8.63137 14.1672 6.33387C14.1672 4.03637 12.2979 2.16699 10.0004 2.16699ZM10.0004 8.83324C8.62223 8.83324 7.50035 7.71137 7.50035 6.33324C7.50035 4.95512 8.62223 3.83324 10.0004 3.83324C11.3785 3.83324 12.5004 4.95512 12.5004 6.33324C12.5004 7.71137 11.3785 8.83324 10.0004 8.83324ZM17.5004 18.0001V17.167C17.5004 13.9514 14.8829 11.3339 11.6672 11.3339H8.3341C5.11723 11.3339 2.50098 13.9514 2.50098 17.167V18.0001H4.16785V17.167C4.16785 14.8695 6.03723 13.0001 8.33473 13.0001H11.6679C13.9654 13.0001 15.8347 14.8695 15.8347 17.167V18.0001H17.5016H17.5004Z"
                      fillOpacity="0.2"
                    />
                  </svg>
                  <span>{t("USER")}</span>
                </div>
              </NavLink>
            </li>
            */}
            {window.localStorage.getItem("role") ===
              Constant.ROLES.ADMIN && (
              <li>
                <div
                  className={
                    isSalesAnalysisRoute
                      ? "active logoutMemu has-arrow"
                      : "has-arrow logoutMemu"
                  }
                  onClick={toggleSalesSubMenu}
                >
                  <div className="left-menu">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.5 3H9.16667V11.3333H2.5V3ZM17.5 3H10.8333V8H17.5V3ZM7.5 9.66667V4.66667H4.16667V9.66667H7.5ZM15.8333 6.33333V4.66667H12.5V6.33333H15.8333ZM15.8333 11.3333V16.3333H12.5V11.3333H15.8333ZM7.5 16.3333V14.6667H4.16667V16.3333H7.5ZM17.5 9.66667H10.8333V18H17.5V9.66667ZM2.5 13H9.16667V18H2.5V13Z"
                      />
                    </svg>
                    <span>{t("CLUB_MANAGER_SALES_ANALYSIS")}</span>
                  </div>
                </div>
                <ul
                  role="menu"
                  className={`sub-menu ${
                    isSalesSubMenuOpen ? "open" : "genres-management"
                  }`}
                >
                  <li
                    className={
                      isSalesAnalysisRoute && salesReportSection === "sales"
                        ? "active"
                        : ""
                    }
                    onClick={() => {
                      setActiveSubMenuItem(null);
                      toggleSlider();
                    }}
                  >
                    <Link
                      role="menuitem"
                      to="/club-sales-analysis?section=sales"
                    >
                      {t("CLUB_ANALYSIS_TAB_SALES")}
                    </Link>
                  </li>
                  <li
                    className={
                      isSalesAnalysisRoute &&
                      salesReportSection === "event-end"
                        ? "active"
                        : ""
                    }
                    onClick={() => {
                      setActiveSubMenuItem(null);
                      toggleSlider();
                    }}
                  >
                    <Link
                      role="menuitem"
                      to="/club-sales-analysis?section=event-end"
                    >
                      {t("CLUB_SALES_MENU_EVENT_END_REPORT")}
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            <li>
              <div
                className={
                  activeSubMenuItem !== null
                    ? "active logoutMemu has-arrow"
                    : "has-arrow logoutMemu"
                }
                onClick={toggleSubMenu}
              >
                <div className="left-menu">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.5 3H9.16667V11.3333H2.5V3ZM17.5 3H10.8333V8H17.5V3ZM7.5 9.66667V4.66667H4.16667V9.66667H7.5ZM15.8333 6.33333V4.66667H12.5V6.33333H15.8333ZM15.8333 11.3333V16.3333H12.5V11.3333H15.8333ZM7.5 16.3333V14.6667H4.16667V16.3333H7.5ZM17.5 9.66667H10.8333V18H17.5V9.66667ZM2.5 13H9.16667V18H2.5V13Z"
                    />
                  </svg>
                  <span>{t("EVENTS")}</span>
                </div>
              </div>
              <ul
                role="menu"
                className={`sub-menu ${isSubMenuOpen ? "open" : "genres-management"
                  }`}
              >
                <li
                  className={
                    activeSubMenuItem === "events-list" ? "active" : ""
                  }
                  onClick={() => {
                    setActiveSubMenuItem("events-list");
                    toggleSlider();
                  }}
                >
                  <Link role="menuitem" to="events-list">
                    {t("EVENTS_LIST")}
                  </Link>
                </li>
                <li
                  className={
                    activeSubMenuItem === "event-phases" ? "active" : ""
                  }
                  onClick={() => {
                    setActiveSubMenuItem("event-phases");
                    toggleSlider();
                  }}
                >
                  <Link role="menuitem" to="events-list/event-phases">
                    {t("EVENT_PHASES_MENU")}
                  </Link>
                </li>
                {window.localStorage.getItem("role") ===
                  Constant.ROLES.ADMIN && (
                  <li
                    className={
                      activeSubMenuItem === "clubs-management" ? "active" : ""
                    }
                    onClick={() => {
                      setActiveSubMenuItem("clubs-management");
                      toggleSlider();
                    }}
                  >
                    <Link role="menuitem" to="clubs-management">
                      {t("CLUBS")}
                    </Link>
                  </li>
                )}
                {window.localStorage.getItem("role") ===
                  Constant.ROLES.ADMIN && (
                  <li
                    className={
                      activeSubMenuItem === "club-managers" ? "active" : ""
                    }
                    onClick={() => {
                      setActiveSubMenuItem("club-managers");
                      toggleSlider();
                    }}
                  >
                    <Link role="menuitem" to="clubs-management/club-managers">
                      {t("CLUB_MANAGERS_MENU")}
                    </Link>
                  </li>
                )}
                <li
                  className={
                    activeSubMenuItem === "category-management" ? "active" : ""
                  }
                  onClick={() => {
                    setActiveSubMenuItem("category-management");
                    toggleSlider();
                  }}
                >
                  <Link role="menuitem" to="category-management">
                    {t("CATEGORY_MANAGEMENT")}
                  </Link>
                </li>
                <li
                  className={
                    activeSubMenuItem === "genres-management" ? "active" : ""
                  }
                  onClick={() => {
                    setActiveSubMenuItem("genres-management");
                    toggleSlider();
                  }}
                >
                  <Link role="menuitem" to="/genres-management">
                    {t("GENRES_MANAGEMENT")}
                  </Link>
                </li>
              </ul>
            </li>
            <li className="mm-active">
              <NavLink
                to="artist-management"
                onClick={() => {
                  setActiveSubMenuItem(null);
                  toggleSlider();
                }}
                className={({ isActive }) => (isActive ? "active" : "inactive")}
              >
                <div className="left-menu">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                  >
                    <path d="M13.333 10.5V5.50004C13.333 3.65254 11.8455 2.14941 10.0174 2.14941C9.95988 2.14941 9.90051 2.15691 9.84301 2.17004C8.07738 2.25316 6.66613 3.71441 6.66613 5.50004V10.5C6.66613 12.3382 8.16113 13.8332 9.99926 13.8332C11.8374 13.8332 13.333 12.3382 13.333 10.5ZM8.33301 10.5V5.50004C8.33301 4.58066 9.08051 3.83316 9.99988 3.83316C10.0455 3.83316 10.0905 3.82879 10.1355 3.82066C10.9899 3.88316 11.6661 4.61254 11.6661 5.50004V10.5C11.6661 11.4194 10.9186 12.1669 9.99926 12.1669C9.07988 12.1669 8.33238 11.4194 8.33238 10.5H8.33301ZM4.99988 10.5H3.33301C3.33301 13.8932 5.88363 16.6969 9.16613 17.1094V18.8338H10.833V17.1094C14.1155 16.6969 16.6661 13.8944 16.6661 10.5H14.9993C14.9993 13.2575 12.7568 15.5 9.99926 15.5C7.24176 15.5 4.99988 13.2575 4.99988 10.5Z" />
                  </svg>
                  <span>{t("ARTISTS")}</span>
                </div>
              </NavLink>
              {/* </Link> */}
            </li>
            {window.localStorage.getItem("role") ===
              Constant.ROLES.ADMIN && (
              <li>
                <NavLink
                  to="clubs-table-booking"
                  onClick={() => {
                    setActiveSubMenuItem(null);
                    toggleSlider();
                  }}
                  className={({ isActive }) =>
                    isActive ? "active" : "inactive"
                  }
                >
                  <div className="left-menu">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.5 6.25L10 2.5L17.5 6.25V9.375C17.5 14.375 10 17.5 10 17.5C10 17.5 2.5 14.375 2.5 9.375V6.25ZM5 7.91667V9.375C5 12.3958 10 15.2083 10 15.2083C10 15.2083 15 12.3958 15 9.375V7.91667L10 5.41667L5 7.91667Z"
                        fill="currentColor"
                      />
                    </svg>
                    <span>{t("TABLE_BOOKING_MENU")}</span>
                  </div>
                </NavLink>
              </li>
            )}
            {/* <li>
              <NavLink
                to="notification"
                onClick={() => {
                  setActiveSubMenuItem(null);
                  toggleSlider();
                }}
                className={({ isActive }) => (isActive ? "active" : "inactive")}
              >
                <div className="left-menu">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                  >
                    <path d="M15.8331 11.8219V8.83373C15.8331 6.15311 14.0125 3.89436 11.5456 3.21561C11.3012 2.60061 10.705 2.16748 10 2.16748C9.295 2.16748 8.69812 2.60061 8.45437 3.21561C5.9875 3.89561 4.16687 6.15311 4.16687 8.83373V11.8219L2.74437 13.2444C2.5875 13.4 2.5 13.6119 2.5 13.8337V15.5006C2.5 15.9612 2.8725 16.3337 3.33313 16.3337H16.6662C17.1269 16.3337 17.4994 15.9612 17.4994 15.5006V13.8337C17.4994 13.6119 17.4119 13.4006 17.255 13.2444L15.8331 11.8219ZM15.8331 14.6669H4.16625V14.1787L5.58875 12.7562C5.74563 12.6006 5.83312 12.3887 5.83312 12.1669V8.83373C5.83312 6.53623 7.7025 4.66686 10 4.66686C12.2975 4.66686 14.1669 6.53623 14.1669 8.83373V12.1669C14.1669 12.3887 14.2544 12.6 14.4112 12.7562L15.8337 14.1787L15.8331 14.6669ZM10 18.8331C11.0925 18.8331 12.0056 18.1381 12.3481 17.1662H7.65125C7.99375 18.1381 8.90687 18.8331 9.99937 18.8331H10Z" />
                  </svg>
                  <span>{t("NOTIFICATION")}</span>
                </div>
              </NavLink>
            </li> */}
          </>
          <li className="menu-title">{t("APPS")}</li>
          <li>
            <NavLink
              to="change-password"
              onClick={() => {
                setActiveSubMenuItem(null);
                toggleSlider();
              }}
              className={({ isActive }) => (isActive ? "active" : "inactive")}
            >
              {/* <Link to="#" className="active"> */}
              <div className="left-menu">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                >
                  <path d="M9.99988 2.16699C7.70238 2.16699 5.83301 4.03637 5.83301 6.33387V8.83387H4.99988C4.08051 8.83387 3.33301 9.58137 3.33301 10.5007V17.1676C3.33301 18.087 4.08051 18.8345 4.99988 18.8345H14.9999C15.9193 18.8345 16.6668 18.087 16.6668 17.1676V10.5007C16.6668 9.58137 15.9193 8.83387 14.9999 8.83387H14.1668V6.33387C14.1668 4.03637 12.2974 2.16699 9.99988 2.16699ZM14.9999 10.5001L15.0018 17.167H4.99988V10.5001H14.9999ZM7.49988 8.83324V6.33324C7.49988 4.95512 8.62176 3.83324 9.99988 3.83324C11.378 3.83324 12.4999 4.95512 12.4999 6.33324V8.83324H7.49988Z" />
                </svg>
                <span>{t("CHANGE_PASSWORD")}</span>
              </div>
            </NavLink>
          </li>
          <li>
            <div
              onClick={(e, item) => {
                openLogoutModal(e, item);
              }}
              className="active logoutMemu"
            >
              {/* <Link to="#" className="active"> */}
              <div className="left-menu">
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M13.0475 12.2031V16.1875C13.0475 16.6562 12.6956 17.0469 12.2269 17.0469H0.859375C0.390625 17.0469 0 16.6562 0 16.1875V1.8125C0 1.34375 0.390625 0.953125 0.859375 0.953125H12.2269C12.6956 0.953125 13.0475 1.34375 13.0475 1.8125V5.79688C13.0475 6.26562 12.6569 6.65625 12.1881 6.65625C11.68 6.65625 11.2894 6.26562 11.2894 5.79688V2.71062H1.75812V15.2887H11.2894V12.2025C11.2894 11.7338 11.68 11.3431 12.1881 11.3431C12.6569 11.3431 13.0475 11.7344 13.0475 12.2031ZM19.7275 8.33625L16.3681 4.89875C16.0162 4.54687 15.4694 4.54687 15.1181 4.89875C14.7669 5.25062 14.7662 5.7975 15.1181 6.14875L17.0325 8.10187L6.48563 8.14125C6.01688 8.14125 5.62625 8.53187 5.62625 9.00062C5.62625 9.46937 6.01688 9.86 6.48563 9.86H17.0325L15.1181 11.8131C14.7662 12.165 14.7662 12.7119 15.1181 13.0631C15.2744 13.2194 15.5087 13.2975 15.7044 13.2975C15.9387 13.2975 16.1731 13.2194 16.3294 13.0631L19.7281 9.62562C20.08 9.235 20.0794 8.68812 19.7275 8.33625Z" />
                </svg>
                <span>{t("LOGOUT")}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <ConfirmModal
        modalTitle={t("LOGOUT")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_LOGOUT_OF_THIS_APP")}
        isUnderline={false}
        showModal={showLogoutModal}
        leftBtnTitle={t("YES_LOGOUT")}
        isModelIcon={true}
        iconColor={"mdi mdi-logout logout"}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="borderButton"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onLogout}
        rightButtonClick={closeLogoutModal}
      />
    </>
  );
};

SidebarContent.propTypes = {
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withTranslation()(SidebarContent);
